import PermitQueuePage from "./permitQueue";

export default PermitQueuePage;